







































import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';

@Component({
  computed: {
    ...mapState({
      globalDialog: 'globalDialog',
    }),
  },
})
export default class QDialog extends Vue {}
